module.exports = __webpack_public_path__ + "static/img/img2.ab9789f1.webp";